<template>
  <div id="filter" class="content-wrapper justify-between">
    <h1 class="search-info" v-if="searchFilter">
      <span class="black-txt">Search results for</span>&nbsp;
      <span style="text-transform:capitalize;">"{{searchFilter}}"</span>
    </h1>

    <h1 class="search-info" v-else>
      <span class="black-txt">Search results:</span>
    </h1>

    <div class="price-filter flex flex-col">
      <h2>
        <span class="black-txt" style="margin-right:8px;">Price range:</span>
        ${{value[0] | formatNum}} to ${{value[1] | formatNum}}
      </h2>
      <div class="slider-wrapper">
        <el-slider
          @change="filterByPrice"
          v-model="value"
          :marks="marks"
          :show-tooltip="false"
          range
          :step="1000"
          :max="100000"
        ></el-slider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reset", "searchFilter"],
  data: () => ({
    value: [0, 100000],
    marks: {
      0: "$0",
      100000: "$100,000"
    }
  }),
  methods: {
    filterByPrice() {
      this.$emit(
        "setPrice",
        `price[]=${this.value[0]}&price[]=${this.value[1]}`
      );
    }
  },
  computed: {},
  watch: {
    reset() {
      if (this.reset) this.value = [0, 100000];
    }
  }
};
</script>

<style>
.el-slider__stop {
  display: none;
}
</style>

<style lang="scss" scoped>
#filter {
  padding: 0 20px;
}
.black-txt {
  color: #0a1f44;
  display: inline-block;
}
.search-info {
  color: #6030b1;
}
h1 {
  padding: 20px 0;
  font-size: 28px;
  line-height: 1.25;
}
h2 {
  margin-bottom: 12px;
  font-size: 20px;
  color: #6030b1;
}
.price-filter {
  width: 30%;
  min-width: 335px;
}
.input-wrapper {
  display: flex;
  position: relative;
  margin-right: 15px;
  button {
    cursor: pointer;
    background-color: white;
    border: none;
    position: absolute;
    width: 40px;
    top: 1px;
    bottom: 1px;
    border-radius: 4px;
    right: 1px;
    .search-icon:hover svg {
      transform: scale(1.25);
    }
  }
  svg {
    height: 100%;
    width: 70%;
    z-index: 10;
    color: rgb(195, 198, 205);
    pointer-events: none;
    transition: all 200ms ease-out;
  }
}
.search {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  width: 180px;
  height: 40px;
  padding: 1px 16px 0 16px;
  font-size: 16px;
  color: #0a1f44;
  display: block;
  position: relative;
  transition: all 200ms ease-out;
  &:focus {
    width: 330px;
    outline: none;
    border-color: #6030b1;
    box-shadow: inset 0 1px #e8ecee;
    outline: none;
    ~ button svg {
      color: rgba(#6030b1, 0.8);
    }
  }
  &::-webkit-input-placeholder {
    color: rgb(195, 198, 205);
  }
}
.search-arrow {
  font-size: 32px;
  margin-right: 12px;
  color: #6030b1;
  cursor: pointer;
  padding: 10px;
  box-sizing: content-box;
}

.top {
  width: 100%;
  margin: 0 auto;
}

@media (max-width: 450px) {
  #filter {
    padding: 0 !important;
  }
  .price-filter {
    // min-width: 265px;
  }
  h2 {
    display: flex;
    flex-direction: column;
    .black-txt {
      margin-bottom: 6px;
    }
  }
  .slider-wrapper {
    width: 70%;
  }
}
</style>